/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductAdminResponse } from '../../models/product-admin-response';

export interface GetProductForAdminById$Params {

/**
 * UUID of the product (PackagingUnit)
 */
  packagingUnitId: string;
}

export function getProductForAdminById(http: HttpClient, rootUrl: string, params: GetProductForAdminById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductAdminResponse>> {
  const rb = new RequestBuilder(rootUrl, getProductForAdminById.PATH, 'get');
  if (params) {
    rb.path('packagingUnitId', params.packagingUnitId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductAdminResponse>;
    })
  );
}

getProductForAdminById.PATH = '/admin/products/{packagingUnitId}';
